import React, { useEffect, useState } from "react";
import axios from "axios";

const LandingPageFront = ({ hideBackground }) => {
    const baseURL = process.env.REACT_APP_Baseurl;

    const [iframeSrc, setIframeSrc] = useState('');
    const [loading, setLoading] = useState(true);
    const [notFound, setNotFound] = useState(false);

    const fetchLandingPage = async () => {
        try {
            const res = await axios.get(`${baseURL}/Front-end/landing-page`);
            const result = res.data?.data;

            if (!result) {
                setNotFound(true);
                return;
            }

            const fullHTML = `
                <!DOCTYPE html>
                <html lang="en">
                <head>
                    <meta charset="UTF-8" />
                    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                    <script src="https://cdn.tailwindcss.com"><\/script>
                    <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700;800;900&display=swap" rel="stylesheet">
                    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css" />
                    <style>${result.custom_css || ''}</style>
                </head>
                <body>
                    ${result.content || ''}
                    <script src="https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js"><\/script>
                    <script>
                        document.addEventListener('DOMContentLoaded', function () {
                            // Swiper init
                            if (typeof Swiper !== 'undefined') {
                                new Swiper('.mySwiper', {
                                    slidesPerView: 2,
                                    spaceBetween: 16,
                                    pagination: { el: '.swiper-pagination', clickable: true },
                                    breakpoints: {
                                        640: { slidesPerView: 3 },
                                        1024: { slidesPerView: 4 },
                                    }
                                });
                            }
                            // Mobile nav toggle
                            const toggle = document.getElementById('navToggle');
                            const drawer = document.getElementById('navDrawer');
                            if (toggle && drawer) {
                                toggle.addEventListener('click', () => {
                                    drawer.classList.toggle('hidden');
                                });
                            }
                        });
                    <\/script>
                </body>
                </html>
            `;

            setIframeSrc(fullHTML);
        } catch (err) {
            console.error("Landing page fetch error:", err);
            setNotFound(true);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLandingPage();
    }, []);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
                <p>Loading landing page...</p>
            </div>
        );
    }

    if (notFound) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
                <h2>Landing Page Not Found</h2>
            </div>
        );
    }

    return (
        <iframe
            srcDoc={iframeSrc}
            style={{
                width: '100%',
                border: 'none',
                display: 'block',
                minHeight: '100vh',
            }}
            title="Landing Page"
            onLoad={(e) => {
                try {
                    const height = e.target.contentDocument.body.scrollHeight;
                    if (height > 0) e.target.style.height = height + 'px';
                } catch (_) {}
            }}
        />
    );
};

export default LandingPageFront;